const rawBaseUrl = import.meta.env.DEV
  ? ''
  : (import.meta.env.VITE_API_URL || '');
const trimmedBaseUrl = rawBaseUrl.replace(/\/$/, '');

export const buildApiUrl = (path) => {
  if (!path) {
    return trimmedBaseUrl;
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${trimmedBaseUrl}${normalizedPath}`;
};

/**
 * ローカル環境かどうかを判定
 * localhost / 127.0.0.1 / プライベートIP（10.x, 172.16-31.x, 192.168.x）
 */
const PRIVATE_IP_RE = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3})$/;
export const isLocalEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || PRIVATE_IP_RE.test(hostname);
};









